import appConfig from '@/features/app/constants/app-config';
import supportedLanguages from '@/features/i18n/constants/supported-languages';
import i18n from 'i18next';
import browserLanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

const supportedLngsKeys = Object.keys(supportedLanguages);

export default function initI18n() {
  return i18n
    .use(initReactI18next)
    .use(browserLanguageDetector)
    .use(
      resourcesToBackend((language: string, namespace: string) => {
        return import(`./locales/${language}/${namespace}.json`).then((data) => {
          return data;
        });
      })
    )
    .init({
      supportedLngs: supportedLngsKeys,
      fallbackLng: supportedLngsKeys[0],
      preload: [supportedLngsKeys[0]],
      interpolation: { escapeValue: false },
      react: {
        transWrapTextNodes: 'span',
      },
      detection: {
        order: ['querystring', 'localStorage', 'navigator'],
        lookupQuerystring: 'lang',
        lookupLocalStorage: appConfig.settingLanguageKey,
      },
    });
}
